import { render, staticRenderFns } from "./ProductDeliveryInfoPopupIframe.vue?vue&type=template&id=4dd8b743&"
import script from "./ProductDeliveryInfoPopupIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductDeliveryInfoPopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports